import { render, staticRenderFns } from "./advertising-detail.vue?vue&type=template&id=316356b5&scoped=true"
import script from "./advertising-detail.vue?vue&type=script&lang=js"
export * from "./advertising-detail.vue?vue&type=script&lang=js"
import style0 from "./advertising-detail.vue?vue&type=style&index=0&id=316356b5&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316356b5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pre-ops-admin 管理后台-预发布环境/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('316356b5')) {
      api.createRecord('316356b5', component.options)
    } else {
      api.reload('316356b5', component.options)
    }
    module.hot.accept("./advertising-detail.vue?vue&type=template&id=316356b5&scoped=true", function () {
      api.rerender('316356b5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/advertising/components/advertising-detail.vue"
export default component.exports